 <div class=" light-bg">
   <div class="col-lg-12" style="padding-bottom: 5px;">
     <div class="">
       <div class="pt-0 pb-0" style="padding:0;">
         <div class="login-block" >
           <div class="m-portlet__body">
             <div>
               <!-- <div class="field-wrapper">
                 <div class="col-sm-3 text-right">{{'USERNAME' | dictionary}}</div>
                 <input [(ngModel)]="userProfileEntity.UserId" (input)="toUpperCaseInput($event)" (blur)="validateUserName()"
                        class="form-control home-login-input-text"
                        aria-describedby="emailHelp"/>
               </div> -->
               <div class="form-group field-wrapper">
                 <div class="col-sm-3 text-right">{{'EMAIL_ADDRESS' | dictionary}}
                 </div>
                 <input type="text" [(ngModel)]="userProfileEntity.EmailAddress"
                        class="form-control home-login-input-text"
                        [disabled]="userInfoConfigurationUserTypeWise.editProfile.emailAddressDisable"
                        aria-describedby="emailHelp"/>
               </div>


               <div class="form-group field-wrapper">
                 <div class="col-sm-3 text-right">{{'CONFIRM_EMAIL_ADDRESS' | dictionary}}
                 </div>
                 <input type="text" [(ngModel)]="userProfileEntity.ConfirmEmailAddress"
                        class="form-control home-login-input-text"
                        [disabled]="userInfoConfigurationUserTypeWise.editProfile.emailAddressDisable"
                        aria-describedby="emailHelp"/>
               </div>


               <div class="form-group field-wrapper checkbox-wrapper">
                 <input id="electronicMailAgreed" name="electronicMailAgreed" type="checkbox"
                        [(ngModel)]="IsElectronicMailSubscribed">
                 <label
                   for="electronicMailAgreed">{{'CHECK_TO_RECEIVE_ELECTRONIC_DELIVERY' | dictionary}}</label>
               </div>

             </div>

             <div>
               <div class="form-group" style="text-align: center; margin-top: 10px">
                 <button (mousedown)="tryScheduleSave()"
                         class="button-1">
                   {{'ACTIVATE' | dictionary}}
                 </button>
                 <button (mousedown)="cancel()"
                         class="ml-15  button-1">
                   {{'CANCEL' | dictionary}}
                 </button>
                 <div class="col-lg-12" style="height: 12px;"></div>
               </div>
             </div>
           </div>
         </div>
       </div>
     </div>
   </div>

   <app-pop-up-dialog [Message]="alertMessage" [Display]="display" (DisplayBack)="onConfirm()">
   </app-pop-up-dialog>

 </div>
